import { useEffect } from 'react'

import { BenefitsSettingsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { trackOpenBenefitsSettingsPage } from 'modules/benefits/lib/trackBenefitsSettings'
import ResetDaySetting from 'modules/benefits/pages/settings/Content/ResetDaySetting'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const BenefitsSettingsPage = () => {
  const { company } = useCurrentSession()
  const { data } = useQuery(BenefitsSettingsPageDocument, {
    variables: { companyId: company.id },
  })

  const nodes = data?.benefits?.benefitSettingsConnection?.nodes ?? []
  const currentResetDay = nodes[0]?.resetDay

  // Track page view with route source
  useEffect(() => {
    const source = window.location.pathname
    trackOpenBenefitsSettingsPage(source)
  }, [])

  // Permissions from page query
  const canEdit = data?.benefits?._policies?.canChangeCycleDay?.can ?? false

  if (currentResetDay === undefined) {
    return null
  }

  return (
    <ResponsivePage.Body>
      <ResetDaySetting companyId={company.id} currentResetDay={currentResetDay} canEdit={canEdit} />
    </ResponsivePage.Body>
  )
}
export default BenefitsSettingsPage
